module.exports = __webpack_public_path__ + "media/images/icons/mailIcon-defd642b1b6b967e903d85de222dd3bf.svg";